export const enum AnchorButtonSizeEnum {
  small = 'small',
  default = 'default',
  large = 'large',
}
